'use client'

import * as Chakra from '@chakra-ui/react'
import { system } from 'shared/theme'
import { ColorModeProvider, ColorModeProviderProps } from '../ColorMode'

export function ChakraProvider(props: ColorModeProviderProps) {
  return (
    <Chakra.ChakraProvider value={system}>
      <ColorModeProvider {...props} />
    </Chakra.ChakraProvider>
  )
}

